<nav>
  <button class="toggle-btn" (click)="menuToggled.emit(true)">
    <i class="fas fa-chevron-left"></i>
  </button>

  <div class="py-4 ps-3 pe-2" *ngIf="!isIncentive">
    <img
      class="mt-lg-2 side-logo-d"
      src="/assets/images/logo-sidebaar.png"
      alt="logo"
    />
    <img
      class="mt-lg-2 side-logo-m"
      src="/assets/images/small-logo.png"
      alt="logo"
    />
  </div>

  <div class="py-3 py-md-4 pe-sm-3 ps-3 pe-2 Isincent" *ngIf="isIncentive">
    <img
      class="mt-lg-2 laplogo navbar-brand"
      src="/assets/images/mines.svg"
      alt="nationalemblem"
    />
    <img
      class="mt-lg-2 phnlogo"
      src="/assets/images/nationalemblem.svg"
      alt="nationalemblem"
    />
    <a class="navbar-brand laplogo" href="/">
      <div class="divider"></div>
    </a>
    <a class="navbar-brand" href="/">
      <img src="/assets/images/jnardc.svg" alt="jnardc Logo" />
    </a>
  </div>

  <div *ngIf="isAdminUser; else notAdmin">
    <div class="nav flex-column">
      <a
        [routerLink]="'/users-management'"
        routerLinkActive="active"
        #rlaAdmin="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_566_3088)">
            <path
              d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z"
              [attr.fill]="rlaAdmin.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
          <defs>
            <clipPath id="clip0_566_3088">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span class="hide-on-collapse ps-3">Dashboard</span>
      </a>
      <a
        [routerLink]="'/manage-requests'"
        routerLinkActive="active"
        #rlaAdmin2="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M2 16V2V6.475V6V16ZM4 10H9.525C9.55833 9.63333 9.64167 9.28333 9.775 8.95C9.90833 8.61667 10.075 8.3 10.275 8H4V10ZM4 14H7.925C8.20833 13.6667 8.53333 13.3958 8.9 13.1875C9.26667 12.9792 9.65 12.8083 10.05 12.675C9.98333 12.575 9.925 12.4667 9.875 12.35C9.825 12.2333 9.78333 12.1167 9.75 12H4V14ZM4 6H14V4H4V6ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V8.45C17.7667 8.01667 17.4833 7.63333 17.15 7.3C16.8167 6.96667 16.4333 6.69167 16 6.475V2H2V16H7.05C7.03333 16.1 7.02083 16.2 7.0125 16.3C7.00417 16.4 7 16.5 7 16.6V18H2ZM14 13C13.3 13 12.7083 12.7583 12.225 12.275C11.7417 11.7917 11.5 11.2 11.5 10.5C11.5 9.8 11.7417 9.20833 12.225 8.725C12.7083 8.24167 13.3 8 14 8C14.7 8 15.2917 8.24167 15.775 8.725C16.2583 9.20833 16.5 9.8 16.5 10.5C16.5 11.2 16.2583 11.7917 15.775 12.275C15.2917 12.7583 14.7 13 14 13ZM9 18V16.6C9 16.2 9.10417 15.8292 9.3125 15.4875C9.52083 15.1458 9.81667 14.9 10.2 14.75C10.8 14.5 11.4208 14.3125 12.0625 14.1875C12.7042 14.0625 13.35 14 14 14C14.65 14 15.2958 14.0625 15.9375 14.1875C16.5792 14.3125 17.2 14.5 17.8 14.75C18.1833 14.9 18.4792 15.1458 18.6875 15.4875C18.8958 15.8292 19 16.2 19 16.6V18H9Z"
            [attr.fill]="rlaAdmin2.isActive ? 'white' : '#4B4B4B'"
          />
        </svg>
        <span class="hide-on-collapse ps-3">Manage Requests</span>
      </a>
      <a
        [routerLink]="'/incentive-scheme'"
        routerLinkActive="active"
        #rlaAdmin6="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_12034_57783"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect
              width="24"
              height="24"
              [attr.fill]="rlaAdmin6.isActive ? 'white' : '#4B4B4B'"
            />
          </mask>
          <g mask="url(#mask0_12034_57783)">
            <path
              d="M12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11ZM7 21V19H11V15.9C10.1833 15.7167 9.45417 15.3708 8.8125 14.8625C8.17083 14.3542 7.7 13.7167 7.4 12.95C6.15 12.8 5.10417 12.2542 4.2625 11.3125C3.42083 10.3708 3 9.26667 3 8V7C3 6.45 3.19583 5.97917 3.5875 5.5875C3.97917 5.19583 4.45 5 5 5H7V3H17V5H19C19.55 5 20.0208 5.19583 20.4125 5.5875C20.8042 5.97917 21 6.45 21 7V8C21 9.26667 20.5792 10.3708 19.7375 11.3125C18.8958 12.2542 17.85 12.8 16.6 12.95C16.3 13.7167 15.8292 14.3542 15.1875 14.8625C14.5458 15.3708 13.8167 15.7167 13 15.9V19H17V21H7ZM7 10.8V7H5V8C5 8.63333 5.18333 9.20417 5.55 9.7125C5.91667 10.2208 6.4 10.5833 7 10.8ZM12 14C12.8333 14 13.5417 13.7083 14.125 13.125C14.7083 12.5417 15 11.8333 15 11V5H9V11C9 11.8333 9.29167 12.5417 9.875 13.125C10.4583 13.7083 11.1667 14 12 14ZM17 10.8C17.6 10.5833 18.0833 10.2208 18.45 9.7125C18.8167 9.20417 19 8.63333 19 8V7H17V10.8Z"
              [attr.fill]="rlaAdmin6.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>
        <span class="hide-on-collapse ps-3">Incentive Scheme</span>
      </a>

      <a
        [routerLink]="'/incentive-form-log'"
        routerLinkActive="active"
        #rlaAdmin6="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_13804_52250"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_13804_52250)">
            <path
              d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
              [attr.fill]="rlaAdmin2.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>

        <span class="hide-on-collapse ps-3">Incentive Form Log</span>
      </a>
      <a
        [routerLink]="'/stakeholder-directory'"
        routerLinkActive="active"
        #rlaAdmin9="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_12057_74871"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_12057_74871)">
            <path
              d="M0 18V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H0ZM6 18V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V18H19.5ZM8.125 16H15.9C15.7333 15.6667 15.2708 15.375 14.5125 15.125C13.7542 14.875 12.9167 14.75 12 14.75C11.0833 14.75 10.2458 14.875 9.4875 15.125C8.72917 15.375 8.275 15.6667 8.125 16ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12ZM12 10C12.2833 10 12.5208 9.90417 12.7125 9.7125C12.9042 9.52083 13 9.28333 13 9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8C11.7167 8 11.4792 8.09583 11.2875 8.2875C11.0958 8.47917 11 8.71667 11 9C11 9.28333 11.0958 9.52083 11.2875 9.7125C11.4792 9.90417 11.7167 10 12 10Z"
              [attr.fill]="rlaAdmin9.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>
        <span class="hide-on-collapse ps-3">Stakeholder Directory</span>
      </a>
      <a
        [routerLink]="'/appointment-requests'"
        routerLinkActive="active"
        #rlaAdmin3="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M19.0781 4H18.0781V2H16.0781V4H8.07812V2H6.07812V4H5.07812C3.97812 4 3.07812 4.9 3.07812 6V20C3.07812 21.1 3.97812 22 5.07812 22H19.0781C20.1781 22 21.0781 21.1 21.0781 20V6C21.0781 4.9 20.1781 4 19.0781 4ZM19.0781 20H5.07812V10H19.0781V20ZM5.07812 8V6H19.0781V8H5.07812ZM7.07812 12H17.0781V14H7.07812V12ZM7.07812 16H14.0781V18H7.07812V16Z"
            [attr.fill]="rlaAdmin3.isActive ? 'white' : '#4B4B4B'"
          />
        </svg>
        <span class="hide-on-collapse ps-3">Appointment Requests</span>
      </a>
      <a
        [routerLink]="'/green-rating'"
        routerLinkActive="active"
        #rlaAdmin5="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_11229_146427"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect
              width="24"
              height="24"
              [attr.fill]="rlaAdmin5.isActive ? 'white' : '#4B4B4B'"
            />
          </mask>
          <g mask="url(#mask0_11229_146427)">
            <path
              d="M9.2 9.2L11.425 5.525L9.95 3.075C9.75 2.74167 9.4625 2.575 9.0875 2.575C8.7125 2.575 8.425 2.74167 8.225 3.075L5.775 7.15L9.2 9.2ZM18.875 16L16.65 12.3L20.125 10.3L21.725 12.975C21.9083 13.2583 22.0083 13.575 22.025 13.925C22.0417 14.275 21.9667 14.6 21.8 14.9C21.6333 15.2333 21.3875 15.5 21.0625 15.7C20.7375 15.9 20.3833 16 20 16H18.875ZM16 23L12 19L16 15V17H20.75L19.3 19.9C19.1167 20.2333 18.8667 20.5 18.55 20.7C18.2333 20.9 17.8833 21 17.5 21H16V23ZM6.325 21C5.99167 21 5.6875 20.9125 5.4125 20.7375C5.1375 20.5625 4.93333 20.3333 4.8 20.05C4.66667 19.7833 4.60417 19.5042 4.6125 19.2125C4.62083 18.9208 4.7 18.65 4.85 18.4L5.7 17H10V21H6.325ZM3.85 18.15L2.225 14.9C2.075 14.6 2.00417 14.2792 2.0125 13.9375C2.02083 13.5958 2.11667 13.275 2.3 12.975L2.7 12.3L1 11.275L6.475 9.9L7.85 15.4L6.125 14.35L3.85 18.15ZM17.35 9.6L11.875 8.225L13.6 7.2L10.475 2H14C14.35 2 14.6792 2.0875 14.9875 2.2625C15.2958 2.4375 15.5417 2.675 15.725 2.975L17.025 5.15L18.725 4.1L17.35 9.6Z"
              [attr.fill]="rlaAdmin5.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>
        <span class="hide-on-collapse ps-3">Green Rating</span>
      </a>
      <a
        [routerLink]="'/industry-rating'"
        routerLinkActive="active"
        #rlaAdmin7="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_11358_55293"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect
              width="24"
              height="24"
              [attr.fill]="rlaAdmin7.isActive ? 'white' : '#4B4B4B'"
            />
          </mask>
          <g mask="url(#mask0_11358_55293)">
            <path
              d="M8 18L12 14.95L16 18L14.5 13.05L18.5 10.2H13.6L12 5L10.4 10.2H5.5L9.5 13.05L8 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
              [attr.fill]="rlaAdmin7.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>
        <span class="hide-on-collapse ps-3">Industry Rating</span>
      </a>
      <a
        [routerLink]="'/help-support'"
        routerLinkActive="active"
        #rlaAdmin4="routerLinkActive"
        class="sidebar-link text-decoration-none p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_8033_31791"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect
              width="24"
              height="24"
              [attr.fill]="rlaAdmin4.isActive ? 'white' : '#4B4B4B'"
            />
          </mask>
          <g mask="url(#mask0_8033_31791)">
            <path
              d="M12 7C12.2833 7 12.5208 6.90417 12.7125 6.7125C12.9042 6.52083 13 6.28333 13 6C13 5.71667 12.9042 5.47917 12.7125 5.2875C12.5208 5.09583 12.2833 5 12 5C11.7167 5 11.4792 5.09583 11.2875 5.2875C11.0958 5.47917 11 5.71667 11 6C11 6.28333 11.0958 6.52083 11.2875 6.7125C11.4792 6.90417 11.7167 7 12 7ZM11 15H13V9H11V15ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
              [attr.fill]="rlaAdmin4.isActive ? 'white' : '#4B4B4B'"
            />
          </g>
        </svg>
        <span class="hide-on-collapse ps-3">Help & Support</span>
      </a>
    </div>
  </div>

  <ng-template #notAdmin>
    <div class="nav flex-column">
      <div class="dashboard-container">
        <div class="tab-header">
          <button
            class="tab-btn"
            [class.active]="activeTab === 'technical'"
            (click)="switchTab('technical')"
          >
            Technical
          </button>
          <button
            class="tab-btn"
            [class.active]="activeTab === 'promotional'"
            (click)="switchTab('promotional')"
          >
            Promotional
          </button>
        </div>
      </div>
      <ng-container *ngIf="activeTab === 'technical'">
        <a
          [routerLink]="'/dashboard'"
          routerLinkActive="active"
          #rla="routerLinkActive"
          class="sidebar-link text-decoration-none p-2"
          [class.active]="activeTechnicalRoute === '/dashboard'"
          (click)="setActiveRoute('/dashboard')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0_566_3088)">
              <path
                d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z"
                [attr.fill]="rla.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
            <defs>
              <clipPath id="clip0_566_3088">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="hide-on-collapse ps-2">Dashboard</span>
        </a>
        <a
          [routerLink]="'/update-profile'"
          routerLinkActive="active"
          #rla1="routerLinkActive"
          class="sidebar-link text-decoration-none p-2"
          [class.active]="activeTechnicalRoute === '/update-profile'"
          (click)="setActiveRoute('/update-profile')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_2686_2480"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla1.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_2686_2480)">
              <path
                d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z"
                [attr.fill]="rla1.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-2">Update Profile</span>
        </a>
        <a
          *ngIf="iseligibleForIncentive"
          href="/applyforinsentive"
          class="sidebar-link text-decoration-none p-2"
          [class.active]="isActive('/applyforinsentive')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_12023_149949"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="
                  isActive('/applyforinsentive') ? 'white' : '#4B4B4B'
                "
              />
            </mask>
            <g mask="url(#mask0_12023_149949)">
              <path
                d="M12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11ZM7 21V19H11V15.9C10.1833 15.7167 9.45417 15.3708 8.8125 14.8625C8.17083 14.3542 7.7 13.7167 7.4 12.95C6.15 12.8 5.10417 12.2542 4.2625 11.3125C3.42083 10.3708 3 9.26667 3 8V7C3 6.45 3.19583 5.97917 3.5875 5.5875C3.97917 5.19583 4.45 5 5 5H7V3H17V5H19C19.55 5 20.0208 5.19583 20.4125 5.5875C20.8042 5.97917 21 6.45 21 7V8C21 9.26667 20.5792 10.3708 19.7375 11.3125C18.8958 12.2542 17.85 12.8 16.6 12.95C16.3 13.7167 15.8292 14.3542 15.1875 14.8625C14.5458 15.3708 13.8167 15.7167 13 15.9V19H17V21H7ZM7 10.8V7H5V8C5 8.63333 5.18333 9.20417 5.55 9.7125C5.91667 10.2208 6.4 10.5833 7 10.8ZM12 14C12.8333 14 13.5417 13.7083 14.125 13.125C14.7083 12.5417 15 11.8333 15 11V5H9V11C9 11.8333 9.29167 12.5417 9.875 13.125C10.4583 13.7083 11.1667 14 12 14ZM17 10.8C17.6 10.5833 18.0833 10.2208 18.45 9.7125C18.8167 9.20417 19 8.63333 19 8V7H17V10.8Z"
                [attr.fill]="
                  isActive('/applyforinsentive') ? 'white' : '#4B4B4B'
                "
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-2">Apply for Incentive Scheme</span>
        </a>
        <a
          *ngIf="this.checkCategory === 'Base non-ferrous metals'"
          [routerLink]="'/industry-rating-form'"
          routerLinkActive="active"
          #rla11="routerLinkActive"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <mask
              id="mask0_11229_146777"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla11.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_11229_146777)">
              <path
                d="M6 16L10 12.95L14 16L12.5 11.05L16.5 8.2H11.6L10 3L8.4 8.2H3.5L7.5 11.05L6 16ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                [attr.fill]="rla11.isActive ? 'white' : '#4B4B4B'"
              />
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Industry Rating</span>
        </a>

        <a
          *ngIf="this.checkCategory === 'Base non-ferrous metals'"
          [routerLink]="'/green-rating-form'"
          routerLinkActive="active"
          #rla11="routerLinkActive"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_11229_146427"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla11.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_11229_146427)">
              <path
                d="M9.2 9.2L11.425 5.525L9.95 3.075C9.75 2.74167 9.4625 2.575 9.0875 2.575C8.7125 2.575 8.425 2.74167 8.225 3.075L5.775 7.15L9.2 9.2ZM18.875 16L16.65 12.3L20.125 10.3L21.725 12.975C21.9083 13.2583 22.0083 13.575 22.025 13.925C22.0417 14.275 21.9667 14.6 21.8 14.9C21.6333 15.2333 21.3875 15.5 21.0625 15.7C20.7375 15.9 20.3833 16 20 16H18.875ZM16 23L12 19L16 15V17H20.75L19.3 19.9C19.1167 20.2333 18.8667 20.5 18.55 20.7C18.2333 20.9 17.8833 21 17.5 21H16V23ZM6.325 21C5.99167 21 5.6875 20.9125 5.4125 20.7375C5.1375 20.5625 4.93333 20.3333 4.8 20.05C4.66667 19.7833 4.60417 19.5042 4.6125 19.2125C4.62083 18.9208 4.7 18.65 4.85 18.4L5.7 17H10V21H6.325ZM3.85 18.15L2.225 14.9C2.075 14.6 2.00417 14.2792 2.0125 13.9375C2.02083 13.5958 2.11667 13.275 2.3 12.975L2.7 12.3L1 11.275L6.475 9.9L7.85 15.4L6.125 14.35L3.85 18.15ZM17.35 9.6L11.875 8.225L13.6 7.2L10.475 2H14C14.35 2 14.6792 2.0875 14.9875 2.2625C15.2958 2.4375 15.5417 2.675 15.725 2.975L17.025 5.15L18.725 4.1L17.35 9.6Z"
                [attr.fill]="rla11.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Green Rating</span>
        </a>

        <!-- <a
          [routerLink]="'/survey-response'"
          routerLinkActive="active"
          #rla2="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/survey-response'"
          (click)="setActiveRoute('/survey-response')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_2693_2522"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla2.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_2693_2522)">
              <path
                d="M2 21V19H22V21H2ZM3 18V11H6V18H3ZM8 18V6H11V18H8ZM13 18V9H16V18H13ZM18 18V3H21V18H18Z"
                [attr.fill]="rla2.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Survey Response</span>
        </a>

        <a
          [routerLink]="'/submit-rd-needs'"
          routerLinkActive="active"
          #rla3="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/submit-rd-needs'"
          (click)="setActiveRoute('/submit-rd-needs')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_2686_2486"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla3.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_2686_2486)">
              <path
                d="M7 17H14V15H7V17ZM7 13H17V11H7V13ZM7 9H17V7H7V9ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z"
                [attr.fill]="rla3.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3"> Submit R&D needs</span>
        </a>
        <a
          [routerLink]="'/apply-for-rating'"
          routerLinkActive="active"
          #rla4="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/apply-for-rating'"
          (click)="setActiveRoute('/apply-for-rating')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_2693_2498"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla4.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_2693_2498)">
              <path
                d="M8 18L12 14.95L16 18L14.5 13.05L18.5 10.2H13.6L12 5L10.4 10.2H5.5L9.5 13.05L8 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                [attr.fill]="rla4.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3"> Apply for Rating</span>
        </a>
        <a
          [routerLink]="'/feedbacks'"
          routerLinkActive="active"
          #rla5="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/feedbacks'"
          (click)="setActiveRoute('/feedbacks')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_2693_2504"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla5.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_2693_2504)">
              <path
                d="M6 14H14V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
                [attr.fill]="rla5.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Feedback</span>
        </a> -->
      </ng-container>

      <ng-container *ngIf="activeTab === 'promotional'">
        <a
          [routerLink]="'/event-and-announcements'"
          routerLinkActive="active"
          #rla8="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/event-and-announcements'"
          (click)="setActiveRoute('/event-and-announcements')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M18.0781 11C18.0781 11.67 18.0781 12.33 18.0781 13C19.2781 13 20.8381 13 22.0781 13C22.0781 12.33 22.0781 11.67 22.0781 11C20.8381 11 19.2781 11 18.0781 11Z"
              [attr.fill]="rla8.isActive ? 'white' : '#4B4B4B'"
            />
            <path
              d="M16.0781 17.61C17.0381 18.32 18.2881 19.26 19.2781 20C19.6781 19.47 20.0781 18.93 20.4781 18.4C19.4881 17.66 18.2381 16.72 17.2781 16C16.8781 16.54 16.4781 17.08 16.0781 17.61Z"
              [attr.fill]="rla8.isActive ? 'white' : '#4B4B4B'"
            />
            <path
              d="M20.4781 5.6C20.0781 5.07 19.6781 4.53 19.2781 4C18.2881 4.74 17.0381 5.68 16.0781 6.4C16.4781 6.93 16.8781 7.47 17.2781 8C18.2381 7.28 19.4881 6.35 20.4781 5.6Z"
              [attr.fill]="rla8.isActive ? 'white' : '#4B4B4B'"
            />
            <path
              d="M4.07812 9C2.97812 9 2.07812 9.9 2.07812 11V13C2.07812 14.1 2.97812 15 4.07812 15H5.07812V19H7.07812V15H8.07812L13.0781 18V6L8.07812 9H4.07812ZM9.10812 10.71L11.0781 9.53V14.47L9.10812 13.29L8.62813 13H4.07812V11H8.62813L9.10812 10.71Z"
              [attr.fill]="rla8.isActive ? 'white' : '#4B4B4B'"
            />
            <path
              d="M15.5781 12C15.5781 10.67 14.9981 9.47 14.0781 8.65V15.34C14.9981 14.53 15.5781 13.33 15.5781 12Z"
              [attr.fill]="rla8.isActive ? 'white' : '#4B4B4B'"
            />
          </svg>
          <span class="hide-on-collapse ps-3">Events & Announcements</span>
        </a>
        <a
          [routerLink]="'/appointment-request-form'"
          routerLinkActive="active"
          #rla6="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/appointment-request-form'"
          (click)="setActiveRoute('/appointment-request-form')"
          class="sidebar-link text-decoration-none p-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M19.0781 4H18.0781V2H16.0781V4H8.07812V2H6.07812V4H5.07812C3.97812 4 3.07812 4.9 3.07812 6V20C3.07812 21.1 3.97812 22 5.07812 22H19.0781C20.1781 22 21.0781 21.1 21.0781 20V6C21.0781 4.9 20.1781 4 19.0781 4ZM19.0781 20H5.07812V10H19.0781V20ZM5.07812 8V6H19.0781V8H5.07812ZM7.07812 12H17.0781V14H7.07812V12ZM7.07812 16H14.0781V18H7.07812V16Z"
              [attr.fill]="rla6.isActive ? 'white' : '#4B4B4B'"
            />
          </svg>
          <span class="hide-on-collapse ps-3">Appointment Booking</span>
        </a>
        <a
          [routerLink]="'/need-support'"
          routerLinkActive="active"
          #rla7="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/need-support'"
          class="sidebar-link text-decoration-none p-2"
          (click)="setActiveRoute('/need-support')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <mask
              id="mask0_10627_60351"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="25"
              height="24"
            >
              <rect
                x="0.078125"
                width="24"
                height="24"
                [attr.fill]="rla7.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_10627_60351)">
              <path
                d="M11.9781 17C12.3281 17 12.624 16.8792 12.8656 16.6375C13.1073 16.3958 13.2281 16.1 13.2281 15.75C13.2281 15.4 13.1073 15.1042 12.8656 14.8625C12.624 14.6208 12.3281 14.5 11.9781 14.5C11.6281 14.5 11.3323 14.6208 11.0906 14.8625C10.849 15.1042 10.7281 15.4 10.7281 15.75C10.7281 16.1 10.849 16.3958 11.0906 16.6375C11.3323 16.8792 11.6281 17 11.9781 17ZM11.0781 13.15H12.9281C12.9281 12.8667 12.9406 12.625 12.9656 12.425C12.9906 12.225 13.0448 12.0333 13.1281 11.85C13.2115 11.6667 13.3156 11.4958 13.4406 11.3375C13.5656 11.1792 13.7448 10.9833 13.9781 10.75C14.5615 10.1667 14.974 9.67917 15.2156 9.2875C15.4573 8.89583 15.5781 8.45 15.5781 7.95C15.5781 7.06667 15.2781 6.35417 14.6781 5.8125C14.0781 5.27083 13.2698 5 12.2531 5C11.3365 5 10.5573 5.225 9.91563 5.675C9.27396 6.125 8.82812 6.75 8.57812 7.55L10.2281 8.2C10.3448 7.75 10.5781 7.3875 10.9281 7.1125C11.2781 6.8375 11.6865 6.7 12.1531 6.7C12.6031 6.7 12.9781 6.82083 13.2781 7.0625C13.5781 7.30417 13.7281 7.625 13.7281 8.025C13.7281 8.30833 13.6365 8.60833 13.4531 8.925C13.2698 9.24167 12.9615 9.59167 12.5281 9.975C12.2448 10.2083 12.0156 10.4375 11.8406 10.6625C11.6656 10.8875 11.5198 11.125 11.4031 11.375C11.2865 11.625 11.2031 11.8875 11.1531 12.1625C11.1031 12.4375 11.0781 12.7667 11.0781 13.15ZM12.0781 23L9.07812 20H5.07812C4.52813 20 4.05729 19.8042 3.66563 19.4125C3.27396 19.0208 3.07812 18.55 3.07812 18V4C3.07812 3.45 3.27396 2.97917 3.66563 2.5875C4.05729 2.19583 4.52813 2 5.07812 2H19.0781C19.6281 2 20.099 2.19583 20.4906 2.5875C20.8823 2.97917 21.0781 3.45 21.0781 4V18C21.0781 18.55 20.8823 19.0208 20.4906 19.4125C20.099 19.8042 19.6281 20 19.0781 20H15.0781L12.0781 23ZM5.07812 18H9.87813L12.0781 20.2L14.2781 18H19.0781V4H5.07812V18Z"
                [attr.fill]="rla7.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Need Support / Helpdesk </span>
        </a>
        <a
          [routerLink]="'/circulars'"
          routerLinkActive="active"
          #rla9="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/circulars'"
          class="sidebar-link text-decoration-none p-2"
          (click)="setActiveRoute('/circulars')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_12711_142712"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla9.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_12711_142712)">
              <path
                d="M4 21V19H16V21H4ZM9.65 16.15L4 10.5L6.1 8.35L11.8 14L9.65 16.15ZM16 9.8L10.35 4.1L12.5 2L18.15 7.65L16 9.8ZM20.6 20L7.55 6.95L8.95 5.55L22 18.6L20.6 20Z"
                [attr.fill]="rla9.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Circulars</span>
        </a>
        <a
          [routerLink]="'/government-policies'"
          routerLinkActive="active"
          #rla10="routerLinkActive"
          [class.active]="activeTechnicalRoute === '/government-policies'"
          class="sidebar-link text-decoration-none p-2"
          (click)="setActiveRoute('/government-policies')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_12711_142944"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect
                width="24"
                height="24"
                [attr.fill]="rla10.isActive ? 'white' : '#4B4B4B'"
              />
            </mask>
            <g mask="url(#mask0_12711_142944)">
              <path
                d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H16L21 8V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V9H15V5H5V19ZM7 17H17V15H7V17ZM7 9H12V7H7V9ZM7 13H17V11H7V13Z"
                [attr.fill]="rla10.isActive ? 'white' : '#4B4B4B'"
              />
            </g>
          </svg>
          <span class="hide-on-collapse ps-3">Government policies</span>
        </a>
      </ng-container>
    </div>
  </ng-template>
</nav>
